import React from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { isString } from 'lodash';

const DateInput = ({
  input, meta,
}) => {
  const { touched, error, warning } = meta;
  const formatedDate = () => {
    if (input.value && input.value !== '') {
      const isoRegex = /[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}Z/;
      if (isString(input.value) && input.value.match(isoRegex)) {
        return moment(input.value, 'YYYY-MM-DDTHH:mm:ssZ');
      }
      return moment(input.value, 'MM/DD/YY hh:mm');
    }
    return moment();
  };
  const selectedValue = formatedDate(input);

  return (
    <span>
      <DatePicker
        style={{ padding: '0' }}
        name={input.name}
        onBlur={input.onBlur}
        onChange={input.onChange}
        onFocus={input.onFocus}
        selected={selectedValue}
        showTimeSelect
        timeFormat='HH:mm'
        timeIntervals={15}
        dateFormat='MM/DD/YY hh:mm'
      />

      {touched
        && ((error && <span className='error-text'>{error}</span>)
          || (warning && <span className='warn-text'>{warning}</span>))}
    </span>
  );
};

DateInput.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
  }).isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
    warning: PropTypes.string,
  }).isRequired,
};

export default DateInput;
